module.exports = __webpack_public_path__ + "img/exclamation-mark-outline.9fe651b.svg";